export default "__VITE_ASSET__Bwc2RhjN__"